import { Stack } from '@mui/joy'
import { useStore, useStoreMap } from 'effector-react'
import { useMemo } from 'react'
import { useParams } from 'react-router-dom'
import { AuditsModal } from '~/widgets/AuditsModal'
import {
  EditPromotion,
  editPromotionModel,
} from '~/features/Promotion/EditPromotion'
import { promotionModel } from '~/entities/Promotion'
import { usePermissions } from '~/entities/viewer'
import { Breadcrumbs, BreadcrumbsList } from '~/shared/ui/Breadcrumbs'
import { Container, PageContainer, PageTitle } from '~/shared/ui/Layout'

export const EditPromotionPage = () => {
  const { promotionId } = useParams<{ promotionId: string }>()

  const { canAuditsView } = usePermissions()

  const isLoading = useStore(promotionModel.requestFx.pending)

  const promotionTitle = useStoreMap(
    editPromotionModel.$promotion,
    (promotion) => promotion?.getTitle(),
  )
  const breadcrumbs: BreadcrumbsList = useMemo(
    () => [
      { title: 'Акция', link: '/promotion' },
      { title: promotionTitle || '' },
    ],
    [promotionTitle],
  )

  return (
    <PageContainer title='Карточка акции'>
      <Container isHeader>
        <Breadcrumbs list={breadcrumbs} lastLoading={isLoading} />
        <Stack direction='row' justifyContent='space-between' spacing={2}>
          <PageTitle>Карточка акции</PageTitle>
          {canAuditsView && promotionId && (
            <AuditsModal auditableId={promotionId} />
          )}
        </Stack>
      </Container>
      <EditPromotion promotionId={promotionId as string} />
    </PageContainer>
  )
}
